import { useEffect, useState } from 'react';

const DEFAULT_DURATION = 60;

/**
 * Drives the resend cool-down shown after a device link is sent. Given the
 * timestamp of the last successful send, returns whether the cool-down is still
 * active and the whole seconds remaining. The remaining time is recomputed from
 * the wall clock each tick, so the window self-expires once the duration elapses.
 */
export function useResendCountdown(sentAt, duration = DEFAULT_DURATION) {
    const [secs, setSecs] = useState(duration);
    const active = Boolean(sentAt) && Date.now() - sentAt < duration * 1000;

    useEffect(() => {
        if (!active) {
            return undefined;
        }
        const interval = setInterval(() => {
            const remaining = duration - Math.floor((Date.now() - sentAt) / 1000);
            setSecs(Math.max(remaining, 0));
        }, 1000);
        return () => clearInterval(interval);
    }, [active, sentAt, duration]);

    return { active, secs };
}
